module.exports = new __parcel__URL__("guide_changelog_text.82cc58ad.png").toString();